export default (function storesInit() {
  const stores = {
    mapInit() {
      const myLatLng = [];
      if(!$('body').hasClass('stores')){
        return
      }
      $('.js--store_data').each((e, elem) => {
        myLatLng.push({lat: Number($(elem).data('lat')), lng: Number($(elem).data('lng'))});
      });

      const map = new google.maps.Map(document.getElementById('map'), {
        zoom: 14,
        center: myLatLng[0],
        fullscreenControl: false,
      });


      myLatLng.forEach((elem) => {
        const marker = new google.maps.Marker({
          position: elem,
          map,
        });
        marker.setMap(map);
      });


      $('.js--to_point').on('click', function () {
        const currentLat = Number($(this).closest('.js--store_data').data('lat'));
        const currentLng = Number($(this).closest('.js--store_data').data('lng'));
        map.panTo({lat: currentLat, lng: currentLng});
      })

    },

    switchCenterMap() {

    },
  };
  $(document).ready(() => {
    stores.mapInit();
  });
}());
